<template>
  <v-dialog
    v-model="authModal.open"
    max-width="556px"
    @update:model-value="closeModal"
  >
    <component
      :is="currentComponent"
      @change="changeModalType"
      @sent="closeModal"
    />
  </v-dialog>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator'

import LoginForm from './LoginForm.vue'
import SignupForm from './SignupForm.vue'
import RegisterForm from './RegisterForm.vue'
import ResetPasswordForm from './ResetPasswordForm.vue'

// TODO Requires rewrite. Everything is bound too tightly.
@Component({
  components: {
    LoginForm,
    SignupForm,
    RegisterForm,
    ResetPasswordForm,
  },
})
export default class AuthModal extends Vue {
  get authModal () {
    return this.$store.getters['ui/authModal']
  }

  get currentComponent () {
    const type = this.authModal.type
    return type.charAt(0).toUpperCase() + type.slice(1) + 'Form'
  }

  changeModalType (type) {
    let data = {}
    if (typeof type == 'string') {
      data = {
        type: type
      }
    } else {
      data = type
    }
    this.$store.dispatch('ui/toggleAuthModal', data)
  }

  closeModal () {
    this.$store.dispatch('ui/toggleAuthModal', {
      open: false,
    })
  }
}
</script>
